import styled from "styled-components";

export const HeaderContainer = styled.div`
  width: 100%;
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ textAlign }) => {
    switch(textAlign) {
      case 'center':
        return 'center';
      case 'right':
        return 'flex-end';
      default:
        return 'flex-start';
    }
  }};
  gap: 16px;
  align-self: stretch;
  text-align: ${({ textAlign }) => textAlign || 'left'};
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: ${({ textAlign }) => {
    switch(textAlign) {
      case 'center':
        return 'center';
      case 'right':
        return 'flex-end';
      default:
        return 'flex-start';
    }
  }};
`;

export const Title = styled.h4`
  color: ${({ theme }) => theme.colors.darkGray};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: ${({ theme }) => theme.fonts.family.inter};
  font-size: ${({ headerSize }) => headerSize || '22px'};
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.25px;
  margin: 0;
`;

export const Description = styled.span`
  color: ${({ theme }) => theme.colors.davysGrey};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: ${({ theme }) => theme.fonts.family.inter};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`; 